(function () {
  'use strict';

  /* =========================================================
     INVI CREATION REGISTER POPUP
     ========================================================= */

  var INIT_KEY = '__INVI_REGISTER_POPUP_INITIALIZED__';

  // Prevent duplicate initialization.
  if (window[INIT_KEY]) {
    return;
  }

  window[INIT_KEY] = true;


  /* =========================================================
     CONFIG
     ========================================================= */

  var FIRST_SHOW_DELAY = 10 * 1000;       // 10 seconds
  var REOPEN_DELAY = 10 * 60 * 1000;      // 10 minutes

  var PHONE_KEY = 'inviPopupPhoneSubmitted';
  var NEXT_SHOW_KEY = 'inviPopupNextShowAt';

  var SHEET_URL =
    'https://script.google.com/macros/s/AKfycbyM4iuWEmWIXl3_p7xd8_DqZK0d-byzuUBJ3G-t5-ZTaXUwWDKqkuaXJDuWfb8T2bXvdQ/exec';


  /* =========================================================
     INITIALIZE AFTER DOM IS READY
     ========================================================= */

  function init() {

    var overlay = document.getElementById('inviRegisterPopupOverlay');

    if (!overlay) {
      return;
    }

    // Prevent this particular popup element from being initialized twice.
    if (overlay.dataset.inviInitialized === 'true') {
      return;
    }

    overlay.dataset.inviInitialized = 'true';


    /* =======================================================
       ELEMENTS
       ======================================================= */

    var closeBtn =
      document.getElementById('inviRegisterPopupClose');

    var form =
      document.getElementById('inviRegisterPopupForm');

    var phoneInput =
      document.getElementById('inviRegisterPopupPhone');

    var phoneError =
      document.getElementById('inviRegisterPopupPhoneError');

    var submitBtn =
      document.getElementById('inviRegisterPopupBtn');


    /* =======================================================
       CUSTOMER STATUS
       ======================================================= */

    var customerLoggedIn =
      overlay.getAttribute('data-customer-logged-in') === 'true';


    /* =======================================================
       TIMER
       ======================================================= */

    var popupTimer = null;


    /* =======================================================
       STORAGE HELPERS
       ======================================================= */

    function getStorage(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }


    function setStorage(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        // Ignore storage errors.
      }
    }


    function removeStorage(key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // Ignore storage errors.
      }
    }


    /* =======================================================
       SUBMISSION STATUS
       ======================================================= */

    function hasSubmittedPhone() {
      return getStorage(PHONE_KEY) === '1';
    }


    function markPhoneSubmitted() {
      setStorage(PHONE_KEY, '1');

      // No need for future popup scheduling.
      removeStorage(NEXT_SHOW_KEY);
    }


    /* =======================================================
       POPUP STATE
       ======================================================= */

    function isPopupOpen() {
      return overlay.classList.contains('is-visible');
    }


    function canShowPopup() {

      if (customerLoggedIn) {
        return false;
      }

      if (hasSubmittedPhone()) {
        return false;
      }

      return true;
    }


    /* =======================================================
       OPEN POPUP
       ======================================================= */

    function openPopup() {

      if (!canShowPopup()) {
        return;
      }

      // Never open another popup if one is already visible.
      if (isPopupOpen()) {
        return;
      }

      overlay.classList.add('is-visible');

      overlay.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';
    }


    /* =======================================================
       CLOSE POPUP
       ======================================================= */

    function closePopup() {

      overlay.classList.remove('is-visible');

      overlay.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = '';

      scheduleNextPopup();
    }


    /* =======================================================
       SCHEDULE NEXT POPUP
       ======================================================= */

    function scheduleNextPopup() {

      if (!canShowPopup()) {
        return;
      }

      // Clear previous timer.
      if (popupTimer) {
        clearTimeout(popupTimer);
        popupTimer = null;
      }


      var now = Date.now();

      var storedNextShow =
        parseInt(getStorage(NEXT_SHOW_KEY), 10);


      /*
       * If a future popup time already exists,
       * respect it instead of creating another schedule.
       */

      if (
        !isNaN(storedNextShow) &&
        storedNextShow > now
      ) {

        var remaining =
          storedNextShow - now;

        popupTimer = setTimeout(function () {

          if (canShowPopup() && !isPopupOpen()) {
            openPopup();
          }

        }, remaining);

        return;
      }


      /*
       * No existing schedule.
       * Create one.
       */

      var nextShow =
        Date.now() + REOPEN_DELAY;

      setStorage(
        NEXT_SHOW_KEY,
        String(nextShow)
      );


      popupTimer = setTimeout(function () {

        removeStorage(NEXT_SHOW_KEY);

        if (
          canShowPopup() &&
          !isPopupOpen()
        ) {
          openPopup();
        }

      }, REOPEN_DELAY);
    }


    /* =======================================================
       CLOSE BUTTON
       ======================================================= */

    if (closeBtn) {

      closeBtn.addEventListener(
        'click',
        function () {
          closePopup();
        }
      );

    }


    /* =======================================================
       CLICK OUTSIDE
       ======================================================= */

    overlay.addEventListener(
      'click',
      function (event) {

        if (event.target === overlay) {
          closePopup();
        }

      }
    );


    /* =======================================================
       ESC KEY
       ======================================================= */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          isPopupOpen()
        ) {
          closePopup();
        }

      }
    );


    /* =======================================================
       PHONE VALIDATION
       ======================================================= */

    function isValidPhone(value) {

      return /^[0-9]{10}$/.test(
        value.trim()
      );

    }


    function showError() {

      if (phoneInput) {
        phoneInput.classList.add('is-error');
      }

      if (phoneError) {
        phoneError.classList.add('is-visible');
      }

    }


    function clearError() {

      if (phoneInput) {
        phoneInput.classList.remove('is-error');
      }

      if (phoneError) {
        phoneError.classList.remove('is-visible');
      }

    }


    /* =======================================================
       PHONE INPUT
       ======================================================= */

    if (phoneInput) {

      phoneInput.addEventListener(
        'input',
        function () {

          phoneInput.value =
            phoneInput.value.replace(
              /[^0-9]/g,
              ''
            );


          if (
            phoneInput.classList.contains('is-error') &&
            isValidPhone(phoneInput.value)
          ) {
            clearError();
          }

        }
      );

    }


    /* =======================================================
       FORM SUBMISSION
       ======================================================= */

    if (form) {

      form.addEventListener(
        'submit',
        function (event) {

          event.preventDefault();


          if (!phoneInput) {
            return;
          }


          var phone =
            phoneInput.value.trim();


          /* -----------------------------------------------
             VALIDATE PHONE
             ----------------------------------------------- */

          if (!isValidPhone(phone)) {

            showError();

            phoneInput.focus();

            return;

          }


          clearError();


          if (submitBtn) {

            submitBtn.disabled = true;

            submitBtn.textContent =
              'Please wait...';

          }


          /* -----------------------------------------------
             SEND TO GOOGLE SHEETS
             ----------------------------------------------- */

          fetch(
            SHEET_URL,
            {
              method: 'POST',

              headers: {
                'Content-Type': 'text/plain'
              },

              body: JSON.stringify({
                phone: phone,
                page: window.location.href
              })
            }
          )

          .then(function (response) {

            /*
             * fetch() does NOT automatically reject
             * on HTTP 4xx / 5xx.
             *
             * Treat only a successful response as success.
             */

            if (!response.ok) {
              throw new Error(
                'Submission failed'
              );
            }

            return response;

          })

          .then(function () {

            /*
             * ONLY mark submitted after
             * successful request.
             */

            markPhoneSubmitted();


            if (popupTimer) {

              clearTimeout(popupTimer);

              popupTimer = null;

            }


            overlay.classList.remove(
              'is-visible'
            );

            overlay.setAttribute(
              'aria-hidden',
              'true'
            );

            document.body.style.overflow = '';

          })

          .catch(function (error) {

            console.error(
              'Invi popup submission error:',
              error
            );

            /*
             * IMPORTANT:
             *
             * DO NOT mark the phone as submitted
             * when the request fails.
             */

            alert(
              'Something went wrong. Please try again.'
            );

          })

          .finally(function () {

            if (submitBtn) {

              submitBtn.disabled = false;

              submitBtn.textContent =
                'Continue';

            }

          });

        }
      );

    }


    /* =======================================================
       INITIAL SHOW
       ======================================================= */

    if (!canShowPopup()) {
      return;
    }


    /*
     * If a future popup was already scheduled,
     * don't create another timer.
     */

    var storedNextShow =
      parseInt(
        getStorage(NEXT_SHOW_KEY),
        10
      );


    if (
      !isNaN(storedNextShow) &&
      storedNextShow > Date.now()
    ) {

      var remaining =
        storedNextShow - Date.now();


      popupTimer = setTimeout(
        function () {

          removeStorage(
            NEXT_SHOW_KEY
          );

          if (
            canShowPopup() &&
            !isPopupOpen()
          ) {
            openPopup();
          }

        },
        remaining
      );


      return;
    }


    /*
     * First visit.
     */

    popupTimer = setTimeout(
      function () {

        if (
          canShowPopup() &&
          !isPopupOpen()
        ) {

          openPopup();

        }

      },
      FIRST_SHOW_DELAY
    );

  }


  /* =========================================================
     DOM READY HANDLING
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );

  } else {

    // Important for dynamically injected Shopify sections.
    init();

  }


  /* =========================================================
     BFCache / PAGESHOW PROTECTION
     ========================================================= */

  window.addEventListener(
    'pageshow',
    function () {

      /*
       * DO NOT restart the popup here.
       *
       * Browser BFCache can restore the page without
       * rebuilding the JavaScript environment.
       *
       * Restarting the timer here is one of the things
       * that can cause duplicate popup schedules.
       */

    }
  );

})();